module.exports = __webpack_public_path__ + "static/media/FD2.db6a9a81.jpg";